import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

import { extractVideoIdFromUrl } from 'features/youtube';

import './MediaYouTube.scss';

const MediaYouTube = ({ videoSrc, isActive = true, handleVideoPlay = () => {} }) => {

	const containerRef = useRef();
	const playerRef = useRef();
	const [ videoHeight, setVideoHeight ] = useState();
	const [ videoWidth, setVideoWidth ] = useState();
	const [ showVideo, setShowVideo ] = useState(false);
	const videoId = extractVideoIdFromUrl(videoSrc);

	// Player configuration
	const opts = {
		height: videoHeight,
		width: videoWidth,
		controls: 1,
		rel: 0,
		origin: 'https://lampsplus.com'
	};

	// Set player size in opts based on container size
	useEffect(() => {

		const aspectRatio = 9 / 16;
		const width = containerRef.current.offsetWidth;
		const height = Math.round(width * aspectRatio);
		setVideoHeight(height);
		setVideoWidth(width);
		setShowVideo(true);

		return () => {

			setShowVideo(false);

		};

	}, []);

	useEffect(() => {

		// reset player if not active (for example when not inside active slide)
		if (!isActive && playerRef.current && typeof playerRef.current.resetPlayer === 'function') {

			setTimeout(() => {

				playerRef.current.resetPlayer();

			}, 500);

		}

	}, [ isActive ]);

	return (
		<div className="MediaYouTube" ref={containerRef}>
			{showVideo && (
				<YouTube ref={playerRef} videoId={videoId} onPlay={() => handleVideoPlay(videoId)} opts={opts} />
			)}
		</div>
	);

};

MediaYouTube.propTypes = {
	videoSrc: PropTypes.string.isRequired,
	isActive: PropTypes.bool,
	handleVideoPlay: PropTypes.func
};

export default MediaYouTube;
